/**
 * Tệp đính kèm sản phẩm — quy tắc THUẦN, kiểm được không cần R2.
 *
 * Khách chốt trần 500MB/tệp và chỉ admin được tải lên/tải về. Trần đó không
 * thể đi trong MỘT yêu cầu: gói Cloudflare của zone chặn thân yêu cầu ở 100MB
 * (kiểm 12/09/2026), và Worker chỉ có 128MB bộ nhớ. Nên trình duyệt cắt tệp
 * thành nhiều phần rồi ghép lại ở R2 — vẫn đi qua domain Hisense.
 */

/** Trần khách đã đồng ý. Không "không giới hạn". */
export const PRODUCT_FILE_MAX_BYTES = 500 * 1024 * 1024;

/**
 * Cỡ một phần: 32MB.
 *
 * Phải dưới trần 100MB của zone, và đủ nhỏ để Worker không giữ quá nhiều trong
 * bộ nhớ; đủ lớn để một tệp 500MB chỉ mất 16 lượt thay vì hàng trăm. R2 buộc
 * mọi phần trừ phần cuối phải BẰNG NHAU.
 */
export const PRODUCT_FILE_PART_BYTES = 32 * 1024 * 1024;

/**
 * Đuôi tệp bị CẤM: những thứ chạy được khi mở.
 *
 * Chặn theo đuôi chứ không theo kiểu MIME do trình duyệt khai: trình duyệt gửi
 * gì cũng được, còn tên tệp là thứ người nhận nhìn thấy và bấm vào.
 */
export const PRODUCT_FILE_BLOCKED_EXTENSIONS = [
  "exe", "com", "bat", "cmd", "msi", "scr", "ps1", "sh", "app", "jar",
  "js", "mjs", "cjs", "vbs", "html", "htm", "svg", "hta", "dll",
];

export type ProductFileRejection = "empty_name" | "too_large" | "blocked_type";

/** Đuôi tệp viết thường, không có dấu chấm. Không có đuôi thì trả chuỗi rỗng. */
export function fileExtension(name: string): string {
  const trimmed = name.trim().toLowerCase();
  const dot = trimmed.lastIndexOf(".");
  return dot > 0 && dot < trimmed.length - 1 ? trimmed.slice(dot + 1) : "";
}

/** null = nhận. Ngược lại là lý do từ chối, để giao diện nói đúng chuyện gì sai. */
export function rejectProductFile(input: { fileName: string; size: number }): ProductFileRejection | null {
  if (!input.fileName.trim()) return "empty_name";
  if (!(input.size > 0) || input.size > PRODUCT_FILE_MAX_BYTES) return "too_large";
  // Đuôi kép kiểu "ban-ve.dwg.exe" phải bị bắt: chỉ xét đuôi CUỐI vì đó là thứ
  // hệ điều hành dùng để quyết định mở bằng gì.
  if (PRODUCT_FILE_BLOCKED_EXTENSIONS.includes(fileExtension(input.fileName))) return "blocked_type";
  return null;
}

/** Số phần cần cắt cho một tệp. */
export function partCount(size: number, partBytes = PRODUCT_FILE_PART_BYTES): number {
  return Math.max(1, Math.ceil(size / partBytes));
}
